import React from 'react';
import ReactSelect from 'react-select';

import './styles.css';

function Select({ className, ...props }) {
  return (
    <ReactSelect className={`LuftSelect ${className || ''}`} {...props} />
  );
}

export default Select;
